import { logger } from '../../../utils/logger';
import { getVoiceService } from '../call-control';

export async function initiateConference(
  _contactId: string,
  target: { skillId?: string; agentId?: string; phoneNumber?: string }
): Promise<void> {
  logger.debug('[CXone SDK] Initiating conference:', target);
  const service = getVoiceService();
  if (target.agentId) {
    await service.consultAgent(parseInt(target.agentId, 10));
  } else if (target.skillId) {
    await service.dialSkill(parseInt(target.skillId, 10));
  } else if (target.phoneNumber) {
    await service.dialPhone({
      phoneNumber: target.phoneNumber,
      skillId: 0,
    });
  }
}

export async function mergeConference(_contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Merging conference');
  const service = getVoiceService();
  await service.conferenceCall();
}

export async function cancelConference(_contactId: string): Promise<void> {
  logger.debug('[CXone SDK] Canceling conference');
  const service = getVoiceService();
  await service.transferContact();
}

export async function dropConferenceParty(_contactId: string, _partyId: string): Promise<void> {
  logger.debug('[CXone SDK] Dropping conference party - not directly supported');
}
